module.exports = __webpack_public_path__ + "img/1.bec2d3db.jpg";